import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './components/layout/layout.component';
import { LoginComponent } from './components/login/login.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { HomeDetailsComponent } from './components/home-details/home-details.component';
import { ParkingComponent } from './components/parking/parking.component';
import { BasementComponent } from './components/basement/basement.component';
import { InteriorComponent } from './components/interior/interior.component';
import { ExteriorComponent } from './components/exterior/exterior.component';
import { ListingDetailsComponent } from './components/listing-details/listing-details.component';
import { MyListingComponent } from './components/my-listing/my-listing.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { canActivateTeam } from './services/authorize-guard.service';
import { PhotosComponent } from './components/photos/photos.component';
import { PlansAddonComponent } from './components/plans-addon/plans-addon.component';
import { AddonComponent } from './components/addon/addon.component';
import { ReviewComponent } from './components/review/review.component';
import { EmailComponent } from './components/email/email.component';
import { SearchComponent } from './components/search/search.component';
import { ValidateEmailComponent } from './components/validate-email/validate-email.component';


const routes: Routes = [
  { path: '', component: SearchComponent },
  { path: 'search', component: LayoutComponent },
  { path: 'signup', component: LoginComponent },
  { path: 'signin', component: SignInComponent },
  { path: 'verify-email', component: EmailComponent },
  {
    path: 'home-details',
    component: HomeDetailsComponent,
    canActivate: [canActivateTeam],
  },
  {
    path: 'parking',
    component: ParkingComponent,
    canActivate: [canActivateTeam],
  },
  {
    path: 'basement',
    component: BasementComponent,
    canActivate: [canActivateTeam],
  },
  {
    path: 'interior',
    component: InteriorComponent,
    canActivate: [canActivateTeam],
  },
  {
    path: 'exterior',
    component: ExteriorComponent,
    canActivate: [canActivateTeam],
  },
  {
    path: 'listing-details',
    component: ListingDetailsComponent,
    canActivate: [canActivateTeam],
  },
  {
    path: 'my-listing',
    component: MyListingComponent,
    canActivate: [canActivateTeam],
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'validate-email',
    component: ValidateEmailComponent,
  },
  {
    path: 'photos',
    component: PhotosComponent,
    canActivate: [canActivateTeam],
  },
  {
    path: 'plans',
    component: PlansAddonComponent,
    canActivate: [canActivateTeam],
  },
  {
    path: 'addon',
    component: AddonComponent,
    canActivate: [canActivateTeam],
  },
  {
    path: 'review',
    component: ReviewComponent,
    canActivate: [canActivateTeam],
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
